export const useHaptics = () => {
  const vibrate = (pattern: number | number[]) => {
    if ('vibrate' in navigator) {
      navigator.vibrate(pattern);
    }
  };

  return {
    buzz: () => vibrate(50),
    success: () => vibrate([50, 100, 50]),
    error: () => vibrate([100, 50, 100, 50, 100]),
    winner: () => vibrate([50, 50, 100, 100, 200]),
  };
};
